<script lang="tsx">
import { IconLoading } from '@arco-design/web-vue/es/icon'
import { cloneVNode, Teleport } from 'vue'


export default defineComponent({
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    tip: {
      type: String,
      required: false,
      default: ''
    },
    /**
     * 适应可视窗
     */
    fitView: {
      type: Boolean,
      default: false
    },
    zIndex: {
      type: Number,
      default: 9999
    }
  },
  setup(props, { attrs, slots, emit }) {
    // TODO 作为默认插槽时候组件属性穿透传递给第一个组件
    const show = ref(false)
    const childNode = ref()
    type Pos = {
      left: string
      top: string
      height: string
      width: string
    }
    const uSpinPos = ref<Partial<Pos>>({})

    onMounted(() => {
      function getPos() {
        const el = childNode.value[0].el
        const { offsetTop, offsetLeft, clientWidth, clientHeight } = el
        const left = offsetLeft
        const top = offsetTop
        let height: number, width: number
        if(props.fitView) {
          const { innerHeight, innerWidth } = window
          height = Math.min(innerHeight - top, clientHeight)
          width = Math.min(innerWidth -left, clientWidth )
        } else {
          height = clientHeight
          width = clientWidth
        }
        uSpinPos.value = {
          left: left + 'px',
          top: top + 'px',
          height: height + 'px',
          width: width + 'px'
        }
      }
      watch(
        () => props.loading,
        async val => {
          if(val) {
            getPos()
          }
          show.value = val
        },
        {
          immediate: true
        }
      )
    })
    function onCLick(e: Event) {
      e.stopPropagation()
    }
    return () => {
      childNode.value = slots.default?.() ?? []

      return <>
        {childNode.value}
        {show.value && <Teleport to="body">
          <div class="u-spin" style={{...uSpinPos.value, zIndex: props.zIndex}} onClick={onCLick}>
            <div class="u-spin-icon">
              <IconLoading />
            </div>
            {props.tip ? <div class="u-spin-tip">{props.tip}</div> : null}
          </div>
        </Teleport>}
      </>
    }
  },
})

</script>

<style lang="less">
.u-spin {
  position: fixed;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: rgba(var(--primary-6));
  background: rgba(255,255,255, .6);
  &-tip {
    margin-top: 10px;
  }
}

</style>